var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGenerateCertificate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11239_5828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0941 13.8672H19.4141V0.585938H0.585938V13.8672H6.90586",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0344 11.5234H14.8438C14.8438 10.2938 15.8406 9.29688 17.0703 9.29688V5.15625C15.8406 5.15625 14.8438 4.15937 14.8438 2.92969H5.15625C5.15625 4.15937 4.15937 5.15625 2.92969 5.15625V9.29688C4.15937 9.29688 5.15625 10.2938 5.15625 11.5234H6.96563",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 16.0547C11.8122 16.0547 13.2812 14.5856 13.2812 12.7734C13.2812 10.9613 11.8122 9.49219 10 9.49219C8.18782 9.49219 6.71875 10.9613 6.71875 12.7734C6.71875 14.5856 8.18782 16.0547 10 16.0547Z",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05781 14.2281L5.18945 18.0379L7.1082 17.6739L7.99531 19.4141L9.65195 16.0364",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9418 14.2281L14.8102 18.0379L12.8914 17.6739L12.0043 19.4141L10.3477 16.0364",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1465 5.27344H6.85352",
    stroke: "#757575",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11239_5828"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGenerateCertificate);
export default __webpack_public_path__ + "static/media/ic-generate-certificate.283268ac8af48b5c15c80a1d99435fdb.svg";
export { ForwardRef as ReactComponent };